import { z } from 'zod';

export const ADJUSTMENT_SCHEMA = z.object({
  amount: z.number().optional(),
  amountCurrency: z.string().optional(),
  description: z.string().optional(),
});

export const ADJUSTMENT_JSON_SCHEMA = z.object({
  amount: z.number().optional(),
  amount_currency: z.string().optional(),
  description: z.string().optional(),
});

export const ADJUSTMENTS_RESPONSE_SCHEMA = z
  .object({
    count: z.number(),
    results: ADJUSTMENT_JSON_SCHEMA.array(),
  })
  .describe('ADJUSTMENTS_RESPONSE_SCHEMA');

// https://shippo.atlassian.net/wiki/spaces/DM/pages/103481392/API+INVOICEITEM+Data+Model
export const INVOICE_ITEM_SCHEMA = z.object({
  amount: z.number(),
  carrier: z.string().optional(),
  currency: z.string(),
  description: z.string().nullable(),
  invoice_item_type: z.string(),
  object_created: z.string(),
  object_purpose: z.string().nullable(),
  provider_name: z.string().optional(),
  tracking_number: z.string().optional(),
  transaction: z.string().optional(),
});

export const INVOICE_ITEMS_RESPONSE_SCHEMA = z
  .object({
    count: z.number(),
    next: z.any(),
    previous: z.any(),
    results: INVOICE_ITEM_SCHEMA.array(),
  })
  .describe('INVOICE_ITEMS_RESPONSE_SCHEMA');
